import apiClient, { unwrap } from './client';
import type { ApiEnvelope, Settings } from '@types';

/**
 * Owner-editable defaults (F9.1).
 *
 * CONTRACT GAP (flag for LJP-06): as of LJP-05 the backend exposes NO settings
 * HTTP route — only an internal `settings_service.get_defaults()`. This client
 * is authored against the contract LJP-06 must implement:
 *   GET  /api/v1/settings → data: Settings
 *   PUT  /api/v1/settings → data: Settings (accepts a partial, echoes the merged result)
 * It is fully mocked in MSW today so the UI works standalone.
 */
export const settingsApi = {
  get: async (): Promise<Settings> => {
    const envelope = await apiClient.get<ApiEnvelope<Settings>>('/v1/settings');
    return unwrap(envelope);
  },

  update: async (input: Partial<Settings>): Promise<Settings> => {
    const envelope = await apiClient.put<ApiEnvelope<Settings>>(
      '/v1/settings',
      input
    );
    return unwrap(envelope);
  },
};

export default settingsApi;
